<!--
 * Created by JackCui on 2021/12/16
 -->

<script>
  /**
   * 对现有button-gallery重新封装
   * 主要处理
   * 1. 按钮时间向上触发
   * 2. 按钮显示隐藏通过字段控制
   */
  import {DATA_SPM_KEY} from '../../../const/static'

  export default {
    name: 'buttons',
    props: {
      /**
       * buttonList[].name
       * buttonList[].type
       * buttonList[].size
       * buttonList[].disabled
       * buttonList[].hide
       * buttonList[].tooltip
       * buttonList[].icon
       * buttonList[].spm
       */
      buttons: {
        type: Array,
        default () {
          return []
        }
      },
      position: {
        type: String,
        default: 'horizontal'
      },
      // 按钮大小
      size: {
        type: String,
        default: 'medium'
      },
      maxLength: Number
    },
    data () {
      return {}
    },
    computed: {
      buttonList () {
        return this.buttonsHandle(this.buttons)
      }
    },
    render (h) {
      return (
        <button-gallery
          buttonList={this.buttonList}
          position={this.position}
          maxLength={this.maxLength}
        />
      )
    },
    methods: {
      events (btn) {
        this.$emit('button-click', btn)
      },
      buttonsHandle (buttons) {
        return buttons.filter(v => !v.hide).map(v => {
          const {size, disabled, spm, buttonList: btnList, ...reset} = v
          let buttonList = btnList

          if (Array.isArray(btnList)) {
            buttonList = this.buttonsHandle(btnList)
          }
          return {
            ...reset,
            buttonList,
            size: size || this.size,
            bind: {
              disabled,
              [DATA_SPM_KEY]: spm
            },
            event: {
              click: () => this.events(v)
            }
          }
        })
      }
    }
  }
</script>
